<template>
  <BaseDialog
    v-model="isActive"
    width="302"
    :fullscreen-mobile="false"
    borderless-title
    hide-close-btn
  >
    <v-card elevation="0">
      <v-card-text class="pa-6 text-body-1 text-ui-kit-text-secondary">
        Что-то пошло не так.
      </v-card-text>
      <v-card-actions>
        <v-spacer class="d-none d-sm-block" />
        <BaseMtButton
          color="primary"
          variant="text"
          text="Понятно"
          :block="$display.smAndDown.value"
          @click="hide"
        />
      </v-card-actions>
    </v-card>
  </BaseDialog>
</template>

<script setup lang="ts">
import { useDisplay } from 'vuetify'

const isActive = ref(false)

const $display = useDisplay()

function open() {
  isActive.value = true
}

function hide() {
  isActive.value = false
}

defineExpose({
  open,
  hide,
})
</script>
